var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHigloLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1904 0C13.8043 0 15.2527 1.80796 15.2695 1.8291V8.78906L15.2705 10.1562H15.2383C15.2393 10.0962 14.7872 9.32411 13.2363 8.83105V14.0576C13.2363 14.0576 11.793 15.8875 8.1582 15.8877V8.43652L7.11133 8.42383L6.73828 8.42773C6.10893 8.44085 5.55858 8.48789 5.07812 8.55762V15.8877C1.44326 15.8876 0 14.0576 0 14.0576V5.54199C0.00215483 5.54199 0.00593284 5.54199 0.0185547 5.54199C0.117366 5.6672 0.622825 6.37116 2.03223 6.84375V1.8291C2.04967 1.80716 3.49825 0 7.11133 0V7.26953L8.15723 7.2793H8.1582L8.53027 7.27539C9.15966 7.26228 9.70996 7.21427 10.1904 7.14453V0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHigloLogo);
export default __webpack_public_path__ + "static/media/higlo_logo.6beab240cc8b6f7be6469033eb0148af.svg";
export { ForwardRef as ReactComponent };